var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { omit } from 'ramda';
var formatActParams = function (actionParams, etc) {
    if (actionParams) {
        try {
            return typeof actionParams === 'object' ? actionParams : JSON.parse(actionParams);
        }
        catch (_a) {
            return null;
        }
    }
    return etc;
};
export var formatNavParams = function (params) {
    if (params) {
        var processInstanceId = params.processInstanceId, taskDefinitionKey = params.taskDefinitionKey, processDefinitionKey = params.processDefinitionKey, applicationGroup = params.applicationGroup, applicationCode = params.applicationCode, applicationVersion = params.applicationVersion, modalFormCode = params.modalFormCode, freeFormCode = params.freeFormCode, action = params.action, _force = params.force, actionParams = params.actionParams, etc = __rest(params, ["processInstanceId", "taskDefinitionKey", "processDefinitionKey", "applicationGroup", "applicationCode", "applicationVersion", "modalFormCode", "freeFormCode", "action", "force", "actionParams"]);
        var force = _force === true || _force === 'true';
        if (processInstanceId && taskDefinitionKey) {
            return { $kind: 'task', processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, force: force };
        }
        else if (processDefinitionKey) {
            return __assign({ $kind: 'process', processDefinitionKey: processDefinitionKey,
                force: force }, omit(['instanceId', 'sourceId', 'targetId'], etc));
        }
        else if (applicationGroup && applicationCode && applicationVersion) {
            var appRef = { applicationGroup: applicationGroup, applicationCode: applicationCode, applicationVersion: applicationVersion };
            return freeFormCode
                ? __assign(__assign(__assign({ $kind: 'free' }, appRef), { freeFormCode: freeFormCode, force: force }), etc) : action
                ? __assign(__assign({ $kind: 'act' }, appRef), { action: action, actionParams: formatActParams(actionParams, etc) }) : __assign({ $kind: 'application' }, appRef);
        }
    }
    return null;
};
//# sourceMappingURL=nav.utils.js.map